import { useEffect } from 'react';
import { useAnalytics } from '@/hooks/useAnalytics';
import { useCurrentUser } from '@/providers/CurrentUserProvider';

export function PageTitle({ title }: { title: string }) {
  const { trackPage } = useAnalytics();
  const { currentUser } = useCurrentUser();

  useEffect(() => {
    if (currentUser?.auth) {
      void trackPage(title);
    }
  }, [title, trackPage, currentUser]);

  useEffect(() => {
    const previousTitle = document.title;
    document.title = `${title}${title ? ' - ' : ''}Sami`;

    return () => {
      document.title = previousTitle;
    };
  }, [title]);

  return null;
}
